import Vue from 'vue'
import Vuex from 'vuex'
import conftype from '@/components/Dashboard/Views/conftype/store'
import excmcase from '@/components/Dashboard/Views/excmcase/store'
import confacl from '@/components/Dashboard/Views/confacl/store'
import documenttemplate from '@/components/Dashboard/Views/documenttemplate/store'
import exaborganizationlead from '@/store/modules/exaborganizationlead/'
import excmconsent from '@/store/modules/excmconsent/'
import excmagreement from '@/components/Dashboard/Views/excmagreement/store'
import excmagreementsla from '@/components/Dashboard/Views/excmagreementsla/store'
import excmagreementconsent from '@/store/modules/excmagreementconsent/'
import excmagreementdevice from '@/components/Dashboard/Views/excmagreementdevice/store'
import excmagreementtype from '@/components/Dashboard/Views/excmagreementtype/store'
import excmcar from '@/components/Dashboard/Views/excmcar/store'
import exsborder from '@/components/Dashboard/Views/BusinessBundle/exsborder/store'
import excmcaruserdata from '@/components/Dashboard/Views/excmcaruserdata/store'
import excmsla from '@/components/Dashboard/Views/excmsla/store'
import excmcaseproblem from '@/store/modules/excmcaseproblem/'
import excmcasetype from '@/components/Dashboard/Views/excmcasetype/store'
import excmcustomfieldvalue from '@/store/modules/excmcustomfieldvalue/'
import excmcyclictask from '@/components/Dashboard/Views/excmcyclictask/store'
import excmcustomfield from '@/store/modules/excmcustomfield/'
import excmdailyplan from '@/store/modules/excmdailyplan/'
import excmdailyplanitem from '@/store/modules/excmdailyplanitem/'
import excmteam from '@/store/modules/excmteam/'
import excmteamuserdata from '@/store/modules/excmteamuserdata/'
import excmregion from '@/store/modules/excmregion/'
import excmregionuserdata from '@/store/modules/excmregionuserdata/'
import excmrelationcategory from '@/components/Dashboard/Views/excmrelationcategory/store'
import excmrelationuserdata from '@/store/modules/excmrelationuserdata/'
import excmtask from '@/components/Dashboard/Views/excmtask/store'
import excmtasktype from '@/components/Dashboard/Views/excmtasktype/store'
import excmnote from '@/components/Dashboard/Views/excmnote/store'
import excmdevice from '@/components/Dashboard/Views/excmdevice/store'
import excmdevicebrand from '@/store/modules/excmdevicebrand/'
import excmdevicemodel from '@/store/modules/excmdevicemodel/'
import excmdevicestate from '@/components/Dashboard/Views/excmdevicestate/store'
import excmdevicetype from '@/store/modules/excmdevicetype/'
import excmdeviceperipheral from '@/store/modules/excmdeviceperipheral/'
import excmdeviceperipheraldevice from '@/store/modules/excmdeviceperipheraldevice/'
import excmmessage from '@/components/Dashboard/Views/excmmessage/store'
import exsbbatchnumber from '@/store/modules/exsbbatchnumber/'
import exsbdelivery from '@/store/modules/exsbdelivery/'
import exsbdocument from '@/components/Dashboard/Views/BusinessBundle/exsbdocument/store'
import exsbdocumenttype from '@/store/modules/exsbdocumenttype/'
import exsbinvoice from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/store'
import exsbinvoiceposition from '@/store/modules/exsbinvoiceposition/'
import exsbinvoicestatus from '@/store/modules/exsbinvoicestatus/'
import exsbinvoicetype from '@/store/modules/exsbinvoicetype'
import exsbitem from '@/components/Dashboard/Views/BusinessBundle/exsbitem/store'
import exsbitembrand from '@/components/Dashboard/Views/BusinessBundle/exsbitembrand/store'
import exsbitemscategory from '@/store/modules/exsbitemscategory/'
import exsbitemtype from '@/store/modules/exsbitemtype/'
import exsbmeasure from '@/store/modules/exsbmeasure/'
import exsboperation from '@/store/modules/exsboperation/'
import exsbowner from '@/store/modules/exsbowner/'
import exsbpaymentway from '@/store/modules/exsbpaymentway/'
import exsbperiodtype from '@/store/modules/exsbperiodtype/'
import exsbposition from '@/store/modules/exsbposition/'
import exsbpricegroup from '@/store/modules/exsbpricegroup/'
import exsbpriceitem from '@/store/modules/exsbpriceitem/'
import exsbpricelist from '@/store/modules/exsbpricelist/'
import exsbpricetype from '@/store/modules/exsbpricetype/'
import exsbreason from '@/store/modules/exsbreason/'
import exsbvatrate from '@/store/modules/exsbvatrate/'
import exsbwarehouse from '@/store/modules/exsbwarehouse/'
import exsbwarehouseitem from '@/store/modules/exsbwarehouseitem/'
import exsbwarehousetype from '@/store/modules/exsbwarehousetype/'
import exsbsettlement from '@/store/modules/exsbsettlement/'
import userdata from '@/components/Dashboard/Views/userdata/store'
import userdataaddress from '@/components/Dashboard/Views/userdataaddress/store'
import userdataemployee from '@/components/Dashboard/Views/userdataemployee/store'
import userdatafirm from '@/components/Dashboard/Views/userdatafirm/store'
import user from '@/store/modules/user/'
import excmrelation from '@/components/Dashboard/Views/excmrelation/store'
import excmcalllog from '@/components/Dashboard/Views/excmcalllog/store'
import excmchatbot from '@/components/Dashboard/Views/excmchatbot/store'
import excmcorrespondence from '@/components/Dashboard/Views/excmcorrespondence/store'
import excmtag from '@/store/modules/excmtag'
import excmuserdatastatus from '@/store/modules/excmuserdatastatus/'
import excmuserdataworkplace from '@/store/modules/excmuserdataworkplace/'
import excmuserdatasalesopportunity from '@/store/modules/excmuserdatasalesopportunity/'
import clienttype from '@/store/modules/clienttype'
import application from '@/components/Dashboard/Views/IAMBundle/application/store'
import databaseconnection from '@/store/modules/databaseconnection/'
import internalannouncement from '@/store/modules/internalannouncement'
import server from '@/store/modules/server/'
import sqlscriptexecuted from '@/store/modules/sqlscriptexecuted/'
import ticket from '@/store/modules/ticket/'
import lists from '@/store/modules/lists/'
import log from '@/store/modules/log/'
import excmdispatchtask from '@/store/modules/excmdispatchtask/'
import agreements from '@/components/Dashboard/Views/AgreementsBundle/agreements/store'
import customfields from '@/components/Dashboard/Views/AgreementsBundle/customfields/store'
import externalforms from '@/components/Dashboard/Views/AgreementsBundle/externalforms/store'
import packages from '@/components/Dashboard/Views/AgreementsBundle/packages/store'
import surveys from '@/components/Dashboard/Views/AgreementsBundle/surveys/store'
import surveyresults from '@/components/Dashboard/Views/AgreementsBundle/surveyresults/store'
import clientAgreements from '@/components/Dashboard/Views/Dashboard/client/store'
import promotions from '@/components/Dashboard/Views/AgreementsBundle/promotions/store'
import exsbbank from '@/components/Dashboard/Views/BusinessBundle/exsbbank/store'
import exsbpaymentsmade from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/store'
import exsbrefund from '@/components/Dashboard/Views/BusinessBundle/exsbrefund/store'
import excmnotificationmessage from '@/components/Dashboard/Views/excmnotificationmessage/store'
import exsbmessagesperiodic from '@/components/Dashboard/Views/exsbmessagesperiodic/store'
import financialreport from '@/components/Dashboard/Views/financialreport/store'
import exsbpriceuserdata from '@/components/Dashboard/Views/BusinessBundle/exsbpriceuserdata/store'
import configuration from '@/store/modules/configuration'
import documenttype from '@/components/Dashboard/Views/documenttype/store'

Vue.use(Vuex)

// =======vuex store start===========

const store = new Vuex.Store({
  state: {
    requestURL: '',
    isProcessing: false,
    map: {
      center: {}
    },
    picker: {
      current: ''
    },
    mobileView: false,
    loginTime: '',
    site_name: 'ExCM',
    language: 'pl',
    logoFull: '/static/img/logoFull.png',
    Pusher: {},
    user: {
      avatarPreview: undefined,
      id: 0,
      name: '',
      roles: [],
      surname: '',
      user_employer: null,
      id_client_type: null,
      default_disable_roles_filtering: 0
    },
    modals: {
      uploadDocument: {
        show: 0,
        close: 0,
        changed: 0,
        path: null
      },
      uploadPicture: {
        show: 0,
        close: 0,
        changed: 0,
        path: null
      },
      updateTaskParams: {
        show: 0,
        close: 0,
        changed: 0,
        path: null
      },
      exsbinvoices: {
        update: {
          invoiceReload: 0,
          positionsUpdateShow: 0,
          positionsUpdateClose: 0,
          dataUpdateShow: 0,
          dataUpdateClose: 0,
          idInvoice: 0
        }
      },
      excmdevice: {
        form: {
          show: 0,
          close: 0
        }
      },
      excmdevicemodel: {
        form: {
          show: 0,
          close: 0
        }
      },
      excmdevicebrand: {
        form: {
          show: 0,
          close: 0
        }
      },
      excmdevicetype: {
        form: {
          show: 0,
          close: 0
        }
      },
      excmdeviceperipheraldevice: {
        update: {
          devicePivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          deviceIRI: null,
          created: 0
        }
      },
      exsborder: {
        generateDocument: {
          show: 0,
          close: 0,
          generated: 0,
          order: null
        }
      },
      finishedtaskdocument: {
        create: {
          show: 0,
          task: null,
          close: 0,
          created: 0
        }
      },
      excmteamuserdata: {
        create: {
          show: 0,
          close: 0,
          created: 0,
          team: null
        },
        update: {
          show: 0,
          close: 0,
          updated: 0,
          team: null
        }
      },
      excmregionuserdata: {
        create: {
          show: 0,
          close: 0,
          created: 0,
          region: null
        },
        update: {
          show: 0,
          close: 0,
          updated: 0,
          region: null
        }
      },
      excmrelationuserdata: {
        create: {
          show: 0,
          close: 0,
          created: 0,
          relation: null
        },
        update: {
          show: 0,
          close: 0,
          updated: 0,
          relation: null
        }
      },
      excmcyclictask: {
        create: {
          show: 0,
          agreement: null,
          close: 0,
          created: 0
        },
        update: {
          show: 0,
          close: 0,
          cyclicTask: null,
          updated: 0
        }
      },
      dailyplan: {
        redirection: {
          show: 0,
          serviceman: {}
        },
        move: {
          show: 0,
          dailyPlanItemObject: null,
          moved: 0
        },
        hold: {
          show: 0,
          dailyPlanItemObject: null,
          holded: 0
        }
      },
      userdataaddress: {
        update: {
          userDataAddressPivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          userDataIRI: null,
          created: 0
        }
      },
      userdataemployee: {
        update: {
          userDataEmployeePivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          firmIRI: null,
          created: 0
        }
      },
      userdatafirm: {
        update: {
          userDataFirmPivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          userIRI: null,
          created: 0
        }
      },
      userdata: {
        create: {
          show: 0,
          close: 0,
          created: 0
        },
        changeAvatar: {
          show: 0,
          close: 0,
          changed: 0,
          userData: null
        },
        assignCarCreate: {
          show: 0,
          serviceman: null,
          created: 0,
          close: 0
        },
        assignCarUpdate: {
          show: 0,
          serviceman: null,
          assignation: null,
          updated: 0,
          close: 0
        },
        addToMailerLite: {
          show: 0,
          selectedUsers: []
        }
      },
      excmtask: {
        create: {
          show: 0,
          close: 0,
          created: 0,
          caseIri: null
        },
        dispatch: {
          taskIRI: null,
          show: 0,
          dispatched: 0,
          close: 0
        },
        addToMyCalendar: {
          taskIRI: null,
          show: 0,
          added: 0,
          close: 0
        },
        transfer: {
          taskIRI: null,
          show: 0,
          transfered: 0,
          close: 0
        },
        closeManually: {
          show: 0,
          close: 0,
          closed: 0,
          taskObject: null,
          dailyPlanItemDate: null
        }
      },
      excmagreementconsent: {
        update: {
          consentPivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          agreementIRI: null,
          created: 0
        }
      },
      excmagreementsla: {
        update: {
          slaPivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          agreementIRI: null,
          created: 0
        }
      },
      excmagreement: {
        update: {
          agreement: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          agreement: null,
          show: 0,
          close: 0,
          updated: 0
        }
      },
      excmagreementdevice: {
        update: {
          devicePivot: null,
          show: 0,
          close: 0,
          updated: 0
        },
        create: {
          show: 0,
          close: 0,
          agreementIRI: null,
          created: 0
        }
      },
      profile: {
        update: {
          show: 0,
          userdataObject: {},
          close: 0
        }
      },
      caseType: {
        update: {
          show: 0,
          caseTypeObject: {},
          close: 0
        }
      },
      customFieldValue: {
        create: {
          show: 0,
          parent: {},
          customFieldValueObject: {}
        },
        update: {
          show: 0,
          index: -1,
          customFieldValueObject: {},
          indexUpdated: -1,
          customFieldValueObjectUpdated: {}
        }
      },
      customField: {
        create: {
          show: 0,
          parent: {},
          customFieldObject: {}
        },
        update: {
          show: 0,
          index: -1,
          customFieldObject: {},
          indexUpdated: -1,
          customFieldObjectUpdated: {}
        }
      },
      firm: {
        update: {
          firmObject: {}
        },
        create: {
          show: 0,
          employer: {}
        }
      },
      employee: {
        update: {
          employeeObject: {}
        },
        create: {
          show: 0,
          employer: {}
        }
      },
      department: {
        update: {
          departmentObject: {}
        },
        create: {
          show: 0,
          employer: {}
        }
      }
    },
    checkboxes: {
      selectedTasks: []
    },
    views: {
      firm: {
        show: {
          newDepartment: {
            object: {}
          },
          newEmployee: {
            object: {}
          }
        }
      },
      dashboard: {
        dispatcher: {
          assignedTasksNumber: 0,
          notAssignedTasksNumber: 0,
          availableNumber: 0,
          notAvailableNumber: 0
        }
      }
    },
    filters: {
      applicationFilterCurrentPage: 1,
      applicationFilter: {},
      applicationFilterReference: {
        savedBlockStatus: '',
        subdomain: '',
        domain: '',
        idUserData: null,
        state: 1
      },
      firmFilterCurrentPage: 1,
      firmFilter: {},
      firmFilterReference: {},
      invoiceNotAcceptedCurrentPage: 1,
      invoiceNotAcceptedFilter: {},
      invoiceNotAcceptedReference: {},
      invoiceNotAcceptedPeriodDate: '',
      invoiceNotAcceptedDateType: 1,
      invoiceAcceptedCurrentPage: 1,
      invoiceAcceptedFilter: {},
      invoiceAcceptedReference: {},
      invoiceAcceptedPeriodDate: '',
      invoiceAcceptedDateType: 1,
      invoiceVindicationCurrentPage: 1,
      invoiceVindicationFilter: {},
      invoiceVindicationReference: {},
      invoiceVindicationPeriodDate: '',
      invoiceVindicationDateType: 1,
      agreementsFilterCurrentPage: 1,
      agreementsFilter: {},
      agreementsFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        dateStatusFilter: ''
      },
      agreementsSignedFilterCurrentPage: 1,
      agreementsSignedFilter: {},
      agreementsSignedFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        status: 3,
        dateStatusFilter: ''
      },
      agreementsOffersFilterCurrentPage: 1,
      agreementsOffersFilter: {},
      agreementsOffersFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        type: 1,
        status: 1,
        decisionUser: 0,
        dateStatusFilter: ''
      },
      agreementsWaitingFilterCurrentPage: 1,
      agreementsWaitingFilter: {},
      agreementsWaitingFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        type: 1,
        status: 1,
        decisionUser: 1,
        dateStatusFilter: ''
      },
      agreementsAcceptedFilterCurrentPage: 1,
      agreementsAcceptedFilter: {},
      agreementsAcceptedFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        type: 1,
        status: 3,
        decisionUser: 3,
        dateStatusFilter: ''
      },
      agreementsSignaturePendingFilterCurrentPage: 1,
      agreementsSignaturePendingFilter: {},
      agreementsSignaturePendingFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        status: 5,
        dateStatusFilter: ''
      },
      agreementsRejectedFilterCurrentPage: 1,
      agreementsRejectedFilter: {},
      agreementsRejectedFilterReference: {
        'agreementTags.tag': [],
        number: '',
        idClient: null,
        'agreementItems.item': [],
        'agreementItems.priceGroup': [],
        'agreementItems.priceUserData.priceBrutto[gt]': '',
        'agreementItems.priceUserData.priceBrutto[lt]': '',
        'agreementItems.priceUserData.item': '',
        decisionUser: 5,
        dateStatusFilter: ''
      },
      paymentsMadeFilterCurrentPage: 1,
      paymentsMadeFilter: {},
      paymentsMadeFilterReference: {
        descriptionFilter: '',
        'paymentDate[after]': '',
        'paymentDate[before]': '',
        idEXSBInvoice: null,
        'idEXSBInvoice.idUserData': null,
        bankPayment: 0,
        invoice: 0
      },
      organizationLeadsFilterCurrentPage: 1,
      organizationLeadsFilter: {},
      organizationLeadsFilterReference: {
        state: 1,
        title: '',
        idUserData: null,
        'tags.tag': [],
        idSalesOpportunity: [],
        idStatus: []
      },
      refundFilterCurrentPage: 1,
      refundFilter: {},
      refundFilterReference: {
        description: '',
        'paymentDate[after]': '',
        'paymentDate[before]': '',
        idClient: null
      }
    }
  },
  getters: {
    mapCenter: state => {
      return state.map.center
    },
    siteName: state => {
      return state.site_name
    }
  },
  modules: {
    clienttype,
    conftype,
    confacl,
    documenttemplate,
    exaborganizationlead,
    excmconsent,
    excmagreement,
    excmagreementsla,
    excmagreementconsent,
    excmagreementdevice,
    excmagreementtype,
    excmcase,
    excmcar,
    excmcaruserdata,
    excmdailyplan,
    excmdailyplanitem,
    excmsla,
    excmcasetype,
    excmcaseproblem,
    excmcustomfield,
    excmcustomfieldvalue,
    excmcyclictask,
    excmnote,
    excmtask,
    excmtasktype,
    excmdevice,
    excmdevicebrand,
    excmdevicemodel,
    excmdevicestate,
    excmdevicetype,
    excmdeviceperipheraldevice,
    excmdeviceperipheral,
    excmmessage,
    excmuserdatastatus,
    excmuserdataworkplace,
    // business bundle
    exsbbatchnumber,
    exsbdelivery,
    exsbdocument,
    exsbdocumenttype,
    exsbinvoice,
    exsbinvoiceposition,
    exsbinvoicestatus,
    exsbinvoicetype,
    exsbitem,
    exsbitembrand,
    exsbitemscategory,
    exsbitemtype,
    exsbmeasure,
    exsboperation,
    exsbowner,
    exsbpaymentway,
    exsbperiodtype,
    exsbposition,
    exsbpriceitem,
    exsbpricegroup,
    exsbpricelist,
    exsbpricetype,
    exsbreason,
    exsbvatrate,
    exsbwarehouse,
    exsbwarehouseitem,
    exsbwarehousetype,
    userdata,
    userdataaddress,
    userdataemployee,
    userdatafirm,
    user,
    excmteam,
    excmteamuserdata,
    excmregion,
    excmrelationcategory,
    excmregionuserdata,
    excmrelationuserdata,
    exsbsettlement,
    exsborder,
    excmrelation,
    excmcalllog,
    excmchatbot,
    excmcorrespondence,
    excmtag,
    excmuserdatasalesopportunity,
    application,
    databaseconnection,
    internalannouncement,
    server,
    sqlscriptexecuted,
    ticket,
    lists,
    log,
    excmdispatchtask,
    agreements,
    customfields,
    externalforms,
    packages,
    surveys,
    surveyresults,
    clientAgreements,
    promotions,
    exsbbank,
    exsbpaymentsmade,
    exsbrefund,
    excmnotificationmessage,
    exsbmessagesperiodic,
    financialreport,
    exsbpriceuserdata,
    configuration,
    documenttype
  }
})

// =======vuex store end===========
export default store
